import request from '@/utils/request'
/**
 * 获得审核通过的供应商
 */
//由于后端接口所有将token放在这

// }

//var access_token="abVM1I2-og0L6DNRSWDbRQAGZjlvFq4Z_1637918646"

export const pay_getMerchantInfo = (data) => {
    return request({
        url: `/pay/open/icbc-info`,
        method: 'get',
        data,
    })
}
// 支付
 //  url: `/pay/icbc?access-token=${window.localStorage.getItem("access-token")}`,
export const pay_submit = (data) => {
    return request({
    // url: `/pay/icbc?access-token=${window.localStorage.getItem("access-token")}`,
    url: `/pay/icbc?access-token=${window.localStorage.getItem("access-token")}`,
       //  url: `/pay/icbc?access-token=${access_token}`,
        method: 'get',
        data,
    })
}


//对换优惠券列表
//pqCEtd_q4bs51KnUblaAq5XLKTiE7rdf_1637771627
export const getdiscountcouponlist = (data) => {
    return request({
       // url: `/customer/tickets/my-record?access-token=${access_token}`,
       url: `/customer/tickets/my-record?access-token=${window.localStorage.getItem("access-token")}`,
        method: 'post',
        data,
    })
}


//授权页面的操作
/**
 * 客户是否正常登陆
 */
export const isLogin = (data) => {
    return request({
        url: `customer/default/is-guest`,
        method: 'GET',
        data
    })
}

/**
 * 微信静默授权
 */
export const silentLogin = (data) => {
    return request({
        url: `/customer/default/callback`,
        method: 'GET',
        data
    })
}


//支付完成
export const getpaysuccesss = (data) => {
    return request({
        url: `/pay/icbc/get-order-info`,
        method:'GET',
        data
    })
}



//支付完成
export const getuniqid= (data) => {
    return request({
        url: `/pay/open/get-uniqid`,
        method:'post',
        data
    })
}

//工行数字人民币
export const getTelSb = (data) => {
    return request({
        url: `https://py-wzghszhb.hzhhkeji.com/icbc/getIcbcOpenId`,
        method: 'post',
        data
    })
}

export const baseUri = process.env.VUE_APP_BASE_API 